/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const WalletWidget = dynamic(() => import('./WalletWidget').then(mod => mod.WalletWidget));

export const WalletWidgetConfig = {
  emptyLabel: 'walletWidget',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/walletwidget`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const WalletWidgetEditable = (props: any) => (
  <EditableComponent config={WalletWidgetConfig} {...props}>
    <WalletWidget {...props} />
  </EditableComponent>
);
